import React, { FC } from 'react'
import { SVGProps } from './types'

export const GiftCardEmptyState: FC<SVGProps> = ({ size, color, onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      onClick={onClick}
    >
      <g clipPath="url(#clip0_7996_27127)">
        <path
          d="M26.004 0.311523C26.8581 0.593989 27.3963 1.12641 27.6734 1.98754V14.2087C27.4618 14.7549 27.2013 15.2569 26.6876 15.5712C26.5933 15.629 26.0414 15.8847 25.9767 15.8847H23.3647V15.0193H25.5464C26.1781 15.0193 26.8121 14.3828 26.8121 13.7485V7.2323H6.12933V11.5581H5.26731V2.01499C5.26731 1.94925 5.52203 1.3966 5.57959 1.30124C5.89835 0.771705 6.38189 0.531139 6.93666 0.311523H26.0033L26.004 0.311523ZM26.8121 3.77263V2.44772C26.8121 1.72674 26.1249 1.17265 25.4377 1.1777L7.608 1.17409C6.88414 1.13797 6.12933 1.67617 6.12933 2.44772V3.77263H26.8121ZM26.8121 4.63737H6.12933V6.36756H26.8121V4.63737Z"
          fill="#6B7280"
        />
        <path
          d="M1.80627 12.437L20.647 12.4219C21.6061 12.5642 22.3285 13.2816 22.5034 14.2351L22.5056 26.1341C22.3667 27.1029 21.6126 27.86 20.6477 27.9994H1.95306C0.998218 27.8614 0.271473 27.1325 0.0966225 26.1869V14.2351C0.270034 13.3227 0.908275 12.6567 1.80627 12.437ZM8.33762 13.2895H2.22433C1.59257 13.2895 0.958643 13.926 0.958643 14.5602V20.6979C1.11119 20.5195 1.84081 19.935 1.89909 19.7812C1.93939 19.675 1.71993 19.1859 1.79116 19.0241C1.87391 18.8362 2.77335 18.1377 2.78774 18.0705C2.66541 17.8545 1.78109 17.187 1.77101 16.9984C1.90989 15.4763 3.13744 14.2445 4.65209 14.1058C4.78305 14.1131 5.47238 14.8774 5.59038 15.0471L5.7199 15.1266C5.78754 15.1122 6.48263 14.2091 6.66971 14.1261C6.83089 14.0545 7.31874 14.2749 7.4238 14.2344C7.57778 14.1759 8.15918 13.4434 8.3369 13.2902L8.33762 13.2895ZM10.7618 13.2895H9.65728C9.56014 13.2895 8.48801 14.5371 8.2851 14.6686L8.896 15.1786L10.7618 13.2902V13.2895ZM12.0922 13.3003L9.38817 15.9913C9.47379 16.3403 9.60835 16.6711 9.62202 17.0367L8.6089 18.0257C8.59091 18.1088 9.58316 18.8875 9.62562 19.0978C9.52272 20.099 8.95428 21.0418 8.08434 21.5518C7.83034 21.7006 6.91723 22.0799 6.66971 21.9701C6.48263 21.887 5.78682 20.9847 5.7199 20.9695L4.69095 21.9867C4.32685 21.973 3.9973 21.8379 3.64976 21.7519L0.969436 24.4668C0.940654 25.7505 0.753571 27.0126 2.38335 27.1347L10.5445 27.1043L21.5896 16.0224C21.7493 14.8225 21.7738 13.2751 20.162 13.2859L12.0915 13.2996L12.0922 13.3003ZM5.31839 17.5041C5.42633 16.877 5.24788 16.0788 4.8586 15.5651C4.80608 15.4965 4.44774 15.1172 4.40385 15.0984C4.12538 14.9807 3.34683 15.6381 3.16766 15.8584C3.04606 16.0087 2.687 16.5729 2.7604 16.7477C2.823 16.8973 3.42598 17.3466 3.59507 17.4275C4.01889 17.6298 4.04623 17.5099 4.42975 17.5041C4.72549 17.4998 5.02266 17.5149 5.31767 17.5034L5.31839 17.5041ZM6.23726 17.5077H7.17987C7.22016 17.5077 7.30291 17.5713 7.44179 17.5597C7.7073 17.5388 8.65279 16.9225 8.65063 16.6798C8.64847 16.5014 8.30596 15.9552 8.17717 15.8028C7.99368 15.5854 7.21225 14.9597 6.96328 15.123C6.71432 15.2863 6.29338 15.8685 6.21999 16.1655C6.12573 16.5476 6.30921 17.0887 6.23654 17.5077H6.23726ZM11.839 27.1325H12.9435L21.6421 18.3992V17.2903L11.8397 27.1318L11.839 27.1325ZM5.32199 18.4266C4.60388 18.3551 3.82029 18.4375 3.22594 18.8911C3.12952 18.9648 2.74528 19.3282 2.74672 19.4163C2.75392 19.9423 3.81166 21.0042 4.33621 21.0122C4.42184 21.0136 4.71037 20.7037 4.78233 20.6156C5.2817 20.0022 5.44072 19.1982 5.32271 18.4266H5.32199ZM6.24014 18.4295C6.3049 19.1649 6.01636 19.706 6.4301 20.3685C6.50061 20.4812 6.93234 20.9927 7.02517 21.0114C7.15397 21.0367 7.71953 20.7102 7.84833 20.6119C8.14694 20.3837 8.57508 19.8274 8.64056 19.4554C8.66502 19.3188 8.34626 19.0414 8.22538 18.9453C7.66557 18.5018 6.93738 18.3334 6.24014 18.4302V18.4295ZM14.2624 27.1325H20.3757C21.0075 27.1325 21.6414 26.4961 21.6414 25.8618V19.7241L14.2624 27.1325ZM0.958643 23.131L2.83955 21.2578L2.33154 20.6445C2.20059 20.8482 0.957923 21.9253 0.957923 22.0221V23.131H0.958643Z"
          fill="#6B7280"
        />
        <path
          d="M25.0887 10.6943H19.056V11.5598H25.0887V10.6943Z"
          fill={color}
        />
        <path
          d="M19.9181 8.96387H19.056V9.82933H19.9181V8.96387Z"
          fill="black"
        />
        <path
          d="M21.6414 8.96387H20.7794V9.82933H21.6414V8.96387Z"
          fill="black"
        />
        <path
          d="M23.3654 8.96387H22.5034V9.82933H23.3654V8.96387Z"
          fill="black"
        />
        <path
          d="M25.0887 8.96387H24.2267V9.82933H25.0887V8.96387Z"
          fill="black"
        />
        <path
          d="M3.54399 24.5381H2.68196V25.4035H3.54399V24.5381Z"
          fill="black"
        />
        <path
          d="M5.26803 24.5381H4.40601V25.4035H5.26803V24.5381Z"
          fill="black"
        />
        <path
          d="M6.99135 24.5381H6.12933V25.4035H6.99135V24.5381Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_7996_27127">
          <rect
            width="27.5775"
            height="27.6889"
            fill="white"
            transform="translate(0.0966225 0.311523)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
